// hack for babel-plugin-component

export { default } from '../dof-tab-page/full-page.vue';



// WEBPACK FOOTER //
// ./packages/dof-full-page/index.js